<template>


    <div>
        <!-- 顶部搜索栏 -->
        <div class="header">
            <div class="search-bar">
                <span>🔍</span>
                <input type="text" placeholder="请输入关键词">
            </div>
        </div>

        <!-- 顶部活动横幅 -->
        <div class="banner">
            <h2>618智慧生活购精彩</h2>
            <p>预订最高优惠5200元</p>
            <a href="#" class="banner-btn">前往主会场</a>
        </div>

        <!-- 快捷导航分类 -->
        <div class="category-nav">
            <div class="category-item" v-for="category in categories" :key="category.id">
                <div class="category-icon">{{ category.icon }}</div>
                <div class="category-name">{{ category.categeroyName }}</div>
            </div>
        </div>

        <!-- 新品推荐区域 -->
        <div class="promo-section">
            <div class="section-title">
                新品推荐
                <!-- <a href="#" class="see-more">查看更多></a> -->
            </div>
            <div class="promo-grid">
                <div class="promo-item" v-for="product in newProducts" :key="product.id" @click="viewProduct(product)">
                    <div class="promo-img"> <img :src="product.imgs[0]?.imageUrl" height="120px"> </div>
                    <div class="promo-info">
                        <span class="promo-tag">新品</span>
                        <div class="promo-title">{{ product.productName }}</div>
                        <div class="promo-price">{{ product.productsGetSkuDto?.productsSkuInfoDto?.[0]?.price }}</div>
                        <!-- <div class="promo-original-price">{{ product.originalPrice }}</div>
                        <div class="sold-count">已售{{ product.sold }}件</div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 热销商品 -->
        <div class="promo-section">
            <div class="section-title">
                热销商品
                <!-- <a href="#" class="see-more">查看更多></a> -->
            </div>
            <div class="promo-grid">
                <div class="promo-item" v-for="product in hotProducts" :key="product.id" @click="viewProduct(product)">
                    <div class="promo-img"><img :src="product.imgs[0]?.imageUrl" height="100px" width="100px"></div>
                    <div class="promo-info">
                        <div class="promo-title">{{ product.productName }}</div>
                        <div class="promo-price">{{ product.productsGetSkuDto?.productsSkuInfoDto?.[0]?.price }}</div>
                        <!-- <div class="promo-original-price">{{ product.originalPrice }}</div>
                        <div class="sold-count">已售{{ product.sold }}件</div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 精选榜单 -->
        <div class="ranking-section">
            <div class="section-title">
                精选榜单
                <!-- <a href="#" class="see-more">查看更多></a> -->
            </div>
            <div class="ranking-item" v-for="product in rankingList" :key="product.id" @click="viewProduct(product)">
                <div class="promo-img"> <img :src="product.imgs[0]?.imageUrl" height="100px" width="100px"> </div>
                <div class="ranking-info">
                    <div class="ranking-title">{{ product.productName }}</div>
                    <div class="ranking-price">{{ product.productsGetSkuDto?.productsSkuInfoDto?.[0]?.price }}</div>
                    <!-- <div class="ranking-original-price">{{ item.originalPrice }}</div>
                    <div class="sold-count">已售{{ item.sold }}件</div> -->
                    <!-- <button class="buy-btn">立即购买</button> -->
                </div>
            </div>
        </div>


        <Layfooter></Layfooter>
    </div>
</template>

<script setup lang="ts">
import { Options, Vue } from 'vue-class-component';

import { createApp, ref, computed, watch, onMounted } from "vue";
import Layfooter from '@/components/lay-footer/index.vue';
import { ShopTypeEmun } from '@/httpRequest/ShopEmun';
import { GetListBusinessCategory, Productlist } from '@/httpRequest/ProductRequest';
import { useRouter } from "vue-router/dist/vue-router";
const router = useRouter();
// const categories = ref([


//   { id: 3, categeroyName: '手机数码', icon: '📱' },


//     { id: 7, categeroyName: '美妆饰品', icon: '💄' },
//      { id: 8, categeroyName: '家用电器', icon: '🏠' },
//       { id: 9, categeroyName: '服装鞋包', icon: '👜' },
//        { id: 10, categeroyName: '其他商品', icon: '🔄' },

// ])
const categories = ref([])

const newProducts = ref([])
const rankingList = ref([])
const hotProducts = ref([])
onMounted(async () => {

    GetListBusinessCategoryData(2112010);
    newProductsData();
    rankingListData();
    hotProductsData();
    // initializeTableHead()
    // skuList.value[0].values.push('绿色')


});

const newProductsData = async () => {

    var listInfo = await Productlist({
        pageIndex: 1,
        pageSize: 8,
        shopTypeStatus: ShopTypeEmun.OnlineStore,
        productsToShopId: "7becb2afebf72e045434ddb51cb14906"
    });
    newProducts.value = listInfo.data.list;
    console.log("newProducts" + newProducts.value)
};

const rankingListData = async () => {

    var listInfo = await Productlist({
        pageIndex: 1,
        pageSize: 8,
        shopTypeStatus: ShopTypeEmun.OnlineStore,
        productsToShopId: "7bedef9fefc4b0b27ce072d87bc079a8"
    });
    rankingList.value = listInfo.data.list;

};

const hotProductsData = async () => {

    var listInfo = await Productlist({
        pageIndex: 1,
        pageSize: 8,
        shopTypeStatus: ShopTypeEmun.OnlineStore,
        productsToShopId: "7bedfe65bca111fd0d65d47169dfa5e9"
    });
    hotProducts.value = listInfo.data.list;
    console.log("hotProducts" + hotProducts.value)
};


const GetListBusinessCategoryData = async (data: any) => {
    var resd = await GetListBusinessCategory({
        shopTypeStatus: data,
        location: 1
    });
    console.log("resd" + resd.status)
    if (resd.status == true) {


        categories.value = resd.data.list


    }
    else {

    }


};

const viewProduct = (product: any) => {
    router.push(`/products/ProductsDetails?id=${product.id}`)
};

</script>
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
}

body {
    background-color: #f5f5f5;
    color: #333;
    padding-bottom: 60px;
    /* 为底部导航留出空间 */
}

/* 顶部搜索栏 */
.header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: linear-gradient(135deg, #ff4e7b 0%, #ff6b6b 100%);
    padding: 10px 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.search-bar {
    background-color: white;
    border-radius: 20px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.search-bar input {
    border: none;
    outline: none;
    flex: 1;
    padding: 0 10px;
    font-size: 14px;
}

/* 顶部轮播/活动横幅 */
.banner {
    background: linear-gradient(to right, #4a90e2, #7b68ee);
    color: white;
    padding: 15px;
    text-align: center;
    margin: 10px 15px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.banner h2 {
    font-size: 20px;
    margin-bottom: 5px;
}

.banner p {
    font-size: 14px;
    opacity: 0.9;
    margin-bottom: 10px;
}

.banner-btn {
    display: inline-block;
    background-color: white;
    color: #4a90e2;
    padding: 8px 20px;
    border-radius: 20px;
    font-weight: bold;
    text-decoration: none;
    margin-top: 5px;
}

/* 快捷导航分类 */
.category-nav {
    display: flex;
    justify-content: space-around;
    background-color: white;
    padding: 15px 0;
    margin: 10px 0;
    border-radius: 0 0 15px 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.category-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 60px;
}

.category-icon {
    width: 40px;
    height: 40px;
    background-color: #f0f7ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    color: #4a90e2;
    font-weight: bold;
}

.category-name {
    font-size: 12px;
    color: #666;
}

/* 新品/促销区域 */
.promo-section {
    padding: 15px;
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.see-more {
    font-size: 14px;
    color: #4a90e2;
    text-decoration: none;
}

.promo-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.promo-item {
    background-color: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.promo-img {
    height: 120px;
    background-color: #eef5ff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4a90e2;
    font-size: 14px;
    font-weight: bold;
}

.promo-info {
    padding: 12px;
}

.promo-tag {
    display: inline-block;
    background-color: #ffe7e7;
    color: #ff6b6b;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 4px;
    margin-bottom: 5px;
}

.promo-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
    height: 40px;
    overflow: hidden;
}

.promo-price {
    color: #ff6b6b;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}

.promo-original-price {
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
    margin-bottom: 10px;
}

.sold-count {
    font-size: 12px;
    color: #999;
}

/* 榜单/热销商品区域 */
.ranking-section {
    padding: 0 15px 15px;
}

.ranking-item {
    display: flex;
    background-color: white;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 12px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.ranking-img {
    width: 100px;
    height: 100px;
    background-color: #f0f7ff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4a90e2;
    font-size: 12px;
    font-weight: bold;
}

.ranking-info {
    flex: 1;
    padding: 12px;
    display: flex;
    flex-direction: column;
}

.ranking-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
    height: 40px;
    overflow: hidden;
}

.ranking-price {
    color: #ff6b6b;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}

.ranking-original-price {
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
    margin-bottom: 10px;
}

.buy-btn {
    align-self: flex-start;
    background: linear-gradient(to right, #ff7e5f, #feb47b);
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 20px;
    font-weight: bold;
    margin-top: auto;
    cursor: pointer;
}

/* 底部导航 */


.nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: #666;
    flex: 1;
}

.nav-item.active {
    color: #4a90e2;
}

.nav-icon {
    font-size: 20px;
    margin-bottom: 4px;
}

.nav-text {
    font-size: 12px;
}

/* 响应式调整 */
@media (max-width: 375px) {

    .promo-title,
    .ranking-title {
        font-size: 13px;
    }

    .promo-price,
    .ranking-price {
        font-size: 16px;
    }
}
</style>
